import { FC, useEffect } from 'react';

import { BonusesCard } from '../../components/tariff/bunuses-card';
import { BonusesHistory } from '../../components/tariff/bonuses-history';
import { BonusesInfoPanel } from '../../components/tariff/bonuses-info-panel';
import { usePosthogCapture } from '../../hooks/usePosthogCapture';

export const BonusesTab: FC = () => {
  const captureEvent = usePosthogCapture();

  useEffect(() => {
    captureEvent('bonus_info_viewed', {
      source: 'tariffs_bonuses_tab',
    });
  }, [captureEvent]);

  return (
    <div className="flex flex-col gap-5">
      <BonusesCard />
      <BonusesHistory />
      <BonusesInfoPanel />
    </div>
  );
};
